
import { useTheme } from 'styled-components';
import type { TColorVariant } from '@klv/shared/styles/types';
import { hasImage } from '@klv/shared/utils/functions';
import {
  CtaStatementGrid, ContentContainer, PrimaryImage, StyledCtaStatement, StyledButtons, StyledDisclaimer, StyledHeadline,
} from './styles';

import type { ICtaStatement } from './types';

const CtaStatement = ({
  background = 'dark',
  buttons,
  disclaimer = '',
  headline = '',
  flagColor = 'lavender',
  image = { altText: '' },
  ...rest
}: ICtaStatement) => {
  // Needed so the buttonColor can be set based on the background.
  const theme = useTheme();
  const buttonColor = theme.ctaStatement[background].button as TColorVariant;
  const includesImage = hasImage(image);
  const removeOverlapGrid = flagColor === 'transparent' && includesImage === true;

  return (
    <StyledCtaStatement background={background} {...rest}>
      <CtaStatementGrid>
        <ContentContainer $removeOverlapGrid={removeOverlapGrid}>
          {headline && (
            <StyledHeadline
              colorVariant={background === 'dark' ? 'light' : 'dark'}
              dangerouslySetInnerHTML={{ __html: headline }}
              flagColor={flagColor}
              forwardedAs="h2"
              variant="display2"
            />
          )}
          {buttons !== undefined && <StyledButtons buttons={buttons} buttonColor={buttonColor} variants={['ghost']} />}
        </ContentContainer>
        {includesImage && image?.gatsbyImage && (
          <PrimaryImage
            altText={image.altText}
            imageData={image.gatsbyImage}
            layout="constrained"
          />
        )}
        {disclaimer && (
          <StyledDisclaimer
            $afterButton={buttons !== undefined}
            colorVariant={background === 'dark' ? 'light' : 'dark'}
            dangerouslySetInnerHTML={{ __html: disclaimer }}
            $hasImage={includesImage}
            variant="disclaimer"
          />
        )}
      </CtaStatementGrid>
    </StyledCtaStatement>
  );
};

export default CtaStatement;
